<template lang="pug">
div
  .card
    .container-fluid
      .row
        .col-md-12
          .white-box
            h1.box-title.m-b-0 サイト設定
            p.text-muted.m-b-30.font-13 SWAN Proサイトの画面
              .form-group
                | コピーライト表記
              .form-group
                .col-md-12
                  input.form-control(type='text', v-model='formData.copyright', name='copyright')
              .form-group
                | サイトのスタイル選択
              .form-group
                .col-md-12
                  el-card(class='box-card')
                    div(slot='header')
                      el-radio(v-model="formData.class",label="white") White SWAN(デフォルト)
                    div
                      .col-md-4(style='background-color: #fff')
                        img(src='/static/img/logo/SP-logo-AJ.png')
                      .col-md-12
                        | 基調を黒系にしたデザイン
              .form-group
                .col-md-12
                  el-card(class='box-card')
                    div(slot='header')
                      el-radio(v-model="formData.class",label="black") Black SWAN
                    div
                      .col-md-6(style='background-color: #000')
                        img(src='/static/img/logo/SP-logo-BJ.png')
                      .col-md-12
                        | 基調を黒系にしたデザイン
              .form-group
                .col-md-12
                  el-card(class='box-card')
                    div(slot='header')
                      el-radio(v-model="formData.class",label="firebird") Firebird
                    div
                      .col-md-6(style='background-color: #cf000f')
                        img(src='/static/img/logo/SP-logo-CJ.png')
                      .col-md-12
                        | 基調を暖色系にしたデザイン
              .form-group
              el-button(@click='register', type='primary') 登録


</template>

<script>
import axios from 'axios'

export default {
  name: 'Top',
  data () {
    return {
      formData: {
        'class': '',
        'copyright': ''
      }
    }
  },
  created () {
    axios({
      method: 'GET',
      baseURL: process.env.API_BASE_URL,
      url: '/admin/swan/setting'
    })
      .then((res) => {
        let content = res.data
        console.dir(res.data)
        this.formData.class = content.class
        this.formData.copyright = content.copyright
      })
      .catch((error) => {
        console.log(error)
      })
  },
  methods: {
    register: function () {
      console.dir(this.formData)
      this.$confirm('変更しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        axios({
          method: 'POST',
          baseURL: process.env.API_BASE_URL,
          url: '/admin/swan/setting',
          data: this.formData
        })
          .then((response) => {
            self.result = response
            this.$message({
              type: 'success',
              message: 'success '
            })
          })
          .catch((error) => {
            console.log(error)
            this.$message({
              type: 'info',
              message: 'error'
            })
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'canceled'
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/setting/list.vue